import React from 'react'
import { withRouter } from "react-router-dom";
import './index.less'
import LoginForm from './components/LoginForm'

@withRouter
class AdminLogin extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
    }
  }
  render () {
    return (
      <div className="page-login">
        <div className="page-container">
          <div className="login-header">
            <div className="logo">
              <img src={`${process.env.PUBLIC_URL}/images/logo.png`} />
            </div>
            <div className="sys-name">
              GG-PRO back
            </div>
          </div>
          <div className="page-form">
            <LoginForm />
          </div>
        </div>
        <div className="page-footer">
          技术支持: GG
        </div>
      </div>
    )
  }
}

export default AdminLogin
